import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41987cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manager-comment-container"
}
const _hoisted_2 = { class: "comment-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Manager's Overall Comment"),
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, "👏")
], -1))
const _hoisted_4 = { class: "comment-input" }
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = {
  key: 0,
  class: "button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PillButton = _resolveComponent("PillButton")!

  return (_ctx.showManagerComment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("textarea", {
              ref: "commentTextArea",
              placeholder: "Enter your comment for this staff",
              value: _ctx.comment,
              disabled: !_ctx.canSave,
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
            }, null, 40, _hoisted_5)
          ])
        ]),
        (_ctx.canEdit || _ctx.canSave)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.canSave)
                ? (_openBlock(), _createBlock(_component_PillButton, {
                    key: 0,
                    label: "Save",
                    class: "button",
                    disabled: _ctx.comment === '' || _ctx.comment === null,
                    onClick: _ctx.onSave
                  }, null, 8, ["disabled", "onClick"]))
                : (_ctx.canEdit)
                  ? (_openBlock(), _createBlock(_component_PillButton, {
                      key: 1,
                      class: "button",
                      label: "Edit",
                      onClick: _ctx.onEdit
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}